import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** shadcn's class merge helper: conditional classes + Tailwind conflict resolution. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * How many of `count` items go in a row, at most `most` to a row: the fewest
 * rows, then the fewest to a row. 5 is 3 + 2, 7 is 4 + 3, 9 is 3 + 3 + 3, and
 * 10 is 4 + 4 + 2.
 */
export function perRow(count: number, most: number): number {
  if (count <= most) return Math.max(count, 1);
  return Math.ceil(count / Math.ceil(count / most));
}
